import { ShieldAlert, RefreshCw, Trash2, LogOut } from "lucide-react";

export default function DashboardHeader({
  jobId,
  refreshing,
  clearing,
  onRefresh,
  onClear,
  onLogout,
}) {
  return (
    <header className="border-b-2 border-black">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="border-2 border-black p-2">
            <ShieldAlert className="w-5 h-5" strokeWidth={2} />
          </div>
          <div className="leading-tight">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] opacity-70">
              Forensic Data Extractor
            </p>
            <h1 className="font-chivo text-xl md:text-2xl font-black tracking-tighter">
              Accident Report Triage
            </h1>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button
            data-testid="refresh-btn"
            onClick={onRefresh}
            disabled={!jobId || refreshing}
            className="inline-flex items-center gap-1 border border-black bg-white px-3 py-2 font-mono text-[11px] uppercase tracking-[0.2em] disabled:opacity-40 hover:bg-zinc-100"
          >
            <RefreshCw className={"w-3.5 h-3.5" + (refreshing ? " animate-spin" : "")} />
            {refreshing ? "Refreshing…" : "Refresh"}
          </button>
          <button
            data-testid="clear-btn"
            onClick={onClear}
            disabled={!jobId || clearing}
            className="inline-flex items-center gap-1 border border-black bg-white px-3 py-2 font-mono text-[11px] uppercase tracking-[0.2em] disabled:opacity-40 hover:bg-red-600 hover:text-white hover:border-red-600"
          >
            <Trash2 className="w-3.5 h-3.5" /> Clear
          </button>
          <button
            data-testid="logout-btn"
            onClick={onLogout}
            className="inline-flex items-center gap-1 border border-black bg-white px-3 py-2 font-mono text-[11px] uppercase tracking-[0.2em] hover:bg-black hover:text-white"
          >
            <LogOut className="w-3.5 h-3.5" /> Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
